<template>
  <v-card rounded="lg" style=" height: 100%;">
    <v-card-title
      class="pa-2 pb-0 py-2 justify-center v-card__title"
      style="color: var(--v-btntext-base);"
    >{{ title }}</v-card-title>
    <v-card-text class="py-0">
      <v-chart :option="chartOptions" ref="chart" :style="styleObject" autoresize/>
    </v-card-text>
  </v-card>
</template>

<script>
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { GaugeChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'

use([
  CanvasRenderer,
  GaugeChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent
])

export default {
  name: 'm_GaugeCard',
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: 'light'
  },
  data() {
    return {}
  },
  props: {
    flag: {
      type: Number,
      default: 0
    },
    isDark: {
      type: Boolean,
      default: false
    },
    title: String,
    height: {
      type: String,
      default: '114px'
    },
    color: String,
    unit: {
      type: String,
      default: 'unit'
    },
    min: {
      type: [String, Number],
      default: 0
    },
    max: {
      type: [String, Number],
      default: 100
    },
    value: {
      type: [String, Number],
      default: 0
    }
  },
  computed: {
    styleObject() {
      if (this.height) {
        return { height: this.height }
      } else {
        return {}
      }
    },
    chartOptions() {
      const chartUnit = this.unit
      return {
        series: [
          {
            radius: '100%',
            center: ['50%', '60%'],
            type: 'gauge',
            startAngle: 200,
            endAngle: -20,
            min: this.min,
            max: this.max,
            itemStyle: {
              color: this.color
            },
            progress: {
              show: true,
              width: 5
            },
            pointer: {
              show: false
            },
            axisLine: {
              lineStyle: {
                width: 5,
                color: [[1, '#6B6B7A']]
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            title: {
              show: false
            },
            detail: {
              valueAnimation: true,
              width: '60%',
              lineHeight: 40,
              height: '15%',
              offsetCenter: [0, '-40%'],
              fontWeight: 'bolder',
              formatter: function(value) {
                return (
                  '{value|' + value.toFixed(1) + '}\n{unit|' + chartUnit + '}'
                )
              },
              rich: {
                value: {
                  fontSize: '22px',
                  fontWeight: 'bolder',
                  color: 'auto'
                },
                unit: {
                  fontSize: '14px',
                  color: '#868c9c',
                  padding: [0, 0, 0, 0]
                }
              }
            },
            data: [
              {
                value: 0
              }
            ]
          }
        ]
      }
    }
  },
  mounted() {
    this.changeDark()
    this.changeChartOptions()
  },
  watch: {
    flag(newValue) {
      this.changeChartOptions()
      this.changeDark()
    },
    isDark() {
      this.changeDark()
    }
  },
  methods: {
    changeDark() {
      if (this.isDark) {
        this.$refs.chart.setOption({
          series: [
            {
              detail: {
                rich: {
                  unit: {
                    color: '#868c9c'
                  }
                }
              }
            }
          ]
        })
      } else {
        this.$refs.chart.setOption({
          series: [
            {
              detail: {
                rich: {
                  unit: {
                    color: '#adadad'
                  }
                }
              }
            }
          ]
        })
      }
    },
    changeChartOptions() {
      this.$refs.chart.setOption({
        series: [
          {
            data: [
              {
                value: 0
              }
            ]
          }
        ]
      })
      const ls = this
      setTimeout(function() {
        ls.$refs.chart.setOption({
          series: [
            {
              data: [
                {
                  value: ls.value
                }
              ]
            }
          ]
        })
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.chart {
  height: 150px;
}
.v-card__title {
  font-size: 1.16rem !important;
}
</style>
